import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { ProjectDataPickerComponent } from './project-data-picker.component';

@NgModule({
  declarations: [
    ProjectDataPickerComponent
  ],
  imports: [
    SharedModule
  ],
  exports:[
    ProjectDataPickerComponent
  ]
})
export class ProjectDataPickerModule { }
